import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "message",
  "use": "message-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"message\"><path fill=\"none\" d=\"M17 8.556a7.45 7.45 0 0 1-.8 3.377 7.556 7.556 0 0 1-6.756 4.178 7.449 7.449 0 0 1-3.377-.8L1 17l1.689-5.067a7.449 7.449 0 0 1-.8-3.377A7.556 7.556 0 0 1 6.067 1.8 7.45 7.45 0 0 1 9.444 1h.445A7.538 7.538 0 0 1 17 8.111v.445z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol